module.exports = __webpack_public_path__ + "img/MING.85f80224.jpg";